import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multi-tab',
  imports: [CommonModule],
  templateUrl: './multi-tab.component.html',
  styleUrl: './multi-tab.component.css'
})
export class MultiTabComponent implements OnInit {

  @Input() tabs: { badge?: number, label: string }[] = [];
  @Output() activeTabChange = new EventEmitter<string>();
  activeTab = '';

  ngOnInit() {
    this.activeTab = this.tabs[0]?.label || '';
  }

  setActiveTab(selectedTab: string): void {
    this.activeTab = this.tabs.find(tab => tab.label === selectedTab)?.label || this.activeTab;
    this.activeTabChange.emit(this.activeTab);
  }

}
